<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import router from '../../../router/index';
import { authHeader } from "../../../helpers/auth-header";

import FilterModal from "@/components/modals/filter-modal.vue";
import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import ListingTable from "@/components/listings/listing-table";

import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";

export default {
    components: {
        Layout,
        PageHeader,
        FilterModal,
        ConfirmationModal,
        MessageModal,
        ListingTable,
        InputGroup,
        SelectGroup,
    },
    data() {
        return {
            title: "Admin",
            items: [
                {
                    text: "Admin"
                },
            ],
            filter: {
                name: '',
                email: '',
                status: 2,
                selected_role: '',
            },
            statusOptions: [
                { name: 'All', value: 2 },
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 },
            ],
            roleOptions: [
                { name: 'SuperAdmin', value: 1 },
                { name: 'Management', value: 2 },
            ],
            fields: [                
                { key: 'id', sortable: true, label: 'ID' },
                { key: "name", sortable: true, label: "Name" },
                { key: "email", sortable: true, label: 'Email' },
                { key: "status", label: "Status" },
                { key: "action" },
            ],
            addUrl: `${window.location.origin}/admin/form/add`,
            isModalVisible: false,
        };
    },
    methods: {
        goToEditPage(id) {
            router.push({name: 'Admin Form', params: {id}});
        },

        goToEditPassword(id) {
            router.push({name: 'Admin Edit Password', params: {id}});
        },

        deleteRecord(id) {
            const deleteCallback = async () => {
                await axios.delete(`${process.env.VUE_APP_APIURL}/admin/${id}`, {
                    headers: authHeader(),
                });
                this.filterTable(this.filter);
                this.$refs.confirmationModal.closeModal();
                this.$refs.messageModal.showModal('The record has been deleted');
            }
            this.$refs.confirmationModal.showModal(`Confirm delete admin (ID: ${id})?`, deleteCallback);
        },

        setAdminView(filter) {
            this.filter = Object.assign(this.filter, filter);
        },

        initialSetting() {
            if (typeof(this.filter.selected_role)  === 'string') {
                this.filter.selected_role = this.filter.selected_role.split(',');
            }
        },

        filterTable(filters) {
			const filter = JSON.parse(JSON.stringify(filters));
			this.$refs.listingTable.filterTable(filter);
		},
		resetTable() {
			this.filter = {
				name: '',
                email: '',
                status: 2,
                selected_role: '',
			};
			this.$refs.listingTable.filterTable(this.filter);
		},
		showFilterModal() {
			this.$refs.filterModal.showModal();
		},
		hideModal() {
			this.isModalVisible = false;
		},
		handleSubmit() {
			this.filterTable(this.filter);
			this.$refs.filterModal.closeModal();
		}
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />

        <FilterModal ref="filterModal" :isVisible="isModalVisible" @close="hideModal">
			<form @submit.prevent="handleSubmit">
				<div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <InputGroup v-model="filter.name" type="text" id="name" displayName="Name" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <InputGroup v-model="filter.email" type="text" id="email" displayName="Email" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <SelectGroup id="roles" displayName="Role" v-model="filter.selected_role" :options="roleOptions" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <SelectGroup v-model="filter.status" id="status" displayName="Status" :options="statusOptions" />
                        </div>
                    </div>
				</div>

				<div class="modal-footer">
                    <button type="button" class="clear__btn" @click="resetTable">Clear</button>
                    <button type="submit" class="save__btn">Filter</button>
                </div>
			</form>
		</FilterModal>

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0" style="position: relative;">
                        <div class="filter_buttons">
							<button class="filter_button" @click="showFilterModal">
                                <i class="mdi mdi-filter-variant mr-2 font-size-17"></i>
                                Filter
                            </button>
							<a class="add_new_button" :href="addUrl">
                                <i class="mdi mdi-plus mr-2 font-size-17"></i> 
                                Add New Admin
                            </a> 
						</div>

                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" :initialSetting="initialSetting" path="admin" listName="admins">
                            <template v-slot:cell(status)="row">
                                <div :class="{
                                    'status-red': parseInt(`${row.value}`) === 0,
                                    'status-green': parseInt(`${row.value}`) === 1,
                                }">{{ parseInt(row.value) === 1 ? 'Active' : 'Inactive' }}</div>
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" :to="{name: 'Admin Form', params: {id: item.id}}"><i class="mdi mdi-pencil font-size-18" v-b-tooltip.hover title="Edit"></i></router-link>
                                <router-link class="mr-3 text-primary" :to="{name: 'Admin Edit Password', params: {id: item.id}}"><i class="ri-lock-password-fill font-size-18" v-b-tooltip.hover title="Edit Password"></i></router-link>
                                <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete"
                                    @click="deleteRecord(item.id)">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a>
                            </template>
                        </ListingTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.modal-footer {
    padding-top: 24px;
    padding-left: 0;
    padding-right: 0;
    margin-top: 48px;
    justify-content: space-between;
    border-top: 1px solid rgba(205, 205, 205, 0.5);

    & .clear__btn {
        border: 0;
        background-color: transparent;
        font-family: Nunito;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #505D69;
        text-decoration: underline;
    }

    & .save__btn {
        border: 1px solid #004AAD;
        border-radius: 6px;
        background: #004AAD;
        padding: 9px 20px;
        font-family: Nunito;
        font-weight: 600;
        font-size: 14px;
        color: #fff;
    }
}
</style>